"use client"

import dynamic from "next/dynamic"
import type { ReactNode } from "react"

import { CartProvider } from "@context/cart-context"
import { CartDrawerProvider } from "@context/cart-drawer-context"
import { AnalyticsProvider } from "@context/analytics-context"
import type { AnalyticsConfig } from "@lib/data/analytics"

const CartDrawer = dynamic(() => import("@modules/layout/components/cart-drawer"), {
  ssr: false,
})

type ProvidersProps = {
  children: ReactNode
  analyticsConfig: AnalyticsConfig | null
}

export default function Providers({
  children,
  analyticsConfig,
}: ProvidersProps) {
  return (
    <AnalyticsProvider
      measurementId={analyticsConfig?.measurementId}
      metaPixelId={analyticsConfig?.metaPixelId}
      metaPixelEnabled={analyticsConfig?.metaPixelEnabled}
      metaCapiEnabled={analyticsConfig?.metaCapiEnabled}
      metaCapiStatus={analyticsConfig?.metaCapiStatus}
      metaMarketingConsentPolicy={analyticsConfig?.metaMarketingConsentPolicy}
    >
      <CartProvider>
        <CartDrawerProvider>
          <CartDrawer />
          {children}
        </CartDrawerProvider>
      </CartProvider>
    </AnalyticsProvider>
  )
}
